import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  contractParkingSpotsKey,
  type IncludeFilter,
} from './useAPIGetContractParkingSpots'

import { post } from 'api/apiClient'

type CancelReservationPayload = {
  rentableParkingSpotId: number
}

const cancelReservation = (
  contractUuid: string,
  body: CancelReservationPayload
) =>
  post<void>(
    API_ENDPOINTS.CONTRACT_PARKING_SPOT_RESERVATIONS_CANCEL.replace(
      ':contractUuid',
      contractUuid
    ),
    body,
    z.void()
  )

export const useAPICancelContractParkingSpotReservation = (
  contractUuid: string | undefined
) => {
  const qc = useQueryClient()

  return useMutation({
    mutationKey: contractUuid
      ? ([
          'contracts',
          contractUuid,
          'parking-spots',
          'cancel-reservation',
        ] as const)
      : undefined,
    mutationFn: async (body: CancelReservationPayload) => {
      if (!contractUuid) {
        throw new Error('Missing contractUuid for cancellation')
      }

      return cancelReservation(contractUuid, body)
    },
    retry: false,
    onSuccess: async () => {
      const invalidate = (inc: IncludeFilter) =>
        qc.invalidateQueries({
          queryKey: contractParkingSpotsKey(contractUuid!, inc),
        })

      await Promise.all([invalidate('all'), invalidate('own')])
    },
  })
}
